var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDoubleQuote = function SvgDoubleQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.891 33.838c0-1.48 1.067-2.802 2.561-3.066 2.241-.423 4.429-1.375 6.563-2.908 2.935-2.062 4.429-4.6 4.429-7.614 0-2.749-2.615-2.643-4.696-2.432-7.363.794-12.272-7.031-8.377-13.27 3.735-6.027 13.126-5.762 17.395-.581 6.136 7.455 4.001 20.99-2.828 27.334-3.255 3.014-7.044 4.864-11.419 5.657-1.867.317-3.628-1.216-3.628-3.12Zm25.612 0c0-1.48 1.067-2.802 2.56-3.066 2.242-.423 4.43-1.375 6.564-2.908 2.934-2.062 4.428-4.6 4.428-7.614 0-2.749-2.614-2.643-4.695-2.432-7.364.793-12.273-7.032-8.378-13.323 3.735-6.027 13.126-5.763 17.395-.582 6.136 7.455 4.002 20.99-2.828 27.334-3.255 3.014-7.044 4.864-11.419 5.657-1.866.371-3.627-1.162-3.627-3.066Z",
    fill: "#1F82BF"
  })));
};

export default SvgDoubleQuote;